import { Component, inject, OnDestroy } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { first, Observable, Subject, Subscription } from 'rxjs';

import { ClickActionEvent } from '@bn/primitives';

import { ConfirmationDialogComponent } from '../../../dialog/components/confirmation-dialog/confirmation-dialog.component';
import { ModalState } from '../../../dialog/models';

@Component({
  styleUrls: ['./file-preview.page.scss'],
  templateUrl: './file-preview.page.html',
})
export class FilePreviewPage implements OnDestroy {
  readonly #subscriptions = new Subscription();
  readonly #dialogRef: BsModalRef<ConfirmationDialogComponent> = inject(BsModalRef);
  readonly #onAction = new Subject<ClickActionEvent>();
  data?: ModalState;

  constructor() {
    this.#dialogRef.onHide?.pipe(first()).subscribe((event) => {
      if (event === 'backdrop-click' || event === 'esc') {
        this.#dialogRef.hide();
      }
    });
  }

  ngOnDestroy(): void {
    this.#subscriptions.unsubscribe();
  }

  getOnAction$(): Observable<ClickActionEvent> {
    return this.#onAction.asObservable();
  }
}
